import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  requestToBecomeNode,
  getNodePosition,
  leaveNodeOperatorQueue,
  setRegistrationWindow,
  getRegistrationWindowStatus,
  stopRegistrationWindow,
} from './actions'
import { State } from './types'

const initialState: State = {
  isLoading: false,
  isBecomeNode: false,
  isRegistrationWindowStarted: false,
  isGettingDetails: false,
  node: null,
  registrationWindow: null,
  message: '',
  error: '',
  isLeavingQueue: false,
  isLeavingQueueError: '',
  isLeavingQueueMessage: '',
  isLeavingQueueSuccess: false,
  isSetRegistrationWindowError: '',
  isSetRegistrationWindowMessage: '',
  isSetRegistrationWindowSuccess: false,
}

const becomeNodeSlice = createSlice({
  name: 'node',
  initialState,
  reducers: {
    messageCleanUp: (state) => {
      state.message = ''
      state.error = ''
      state.isLoading = false
      state.isLeavingQueue = false
      state.isLeavingQueueSuccess = false
      state.isLeavingQueueMessage = ''
      state.isLeavingQueueError = ''
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestToBecomeNode.pending, (state) => {
        state.isLoading = true
        state.error = ''
      })
      .addCase(requestToBecomeNode.fulfilled, (state, { payload }: any) => {
        state.isLoading = false
        state.isBecomeNode = true
        state.message = payload.message
        state.node = payload.queueEntry
      })
      .addCase(requestToBecomeNode.rejected, (state, { payload }: any) => {
        state.isLoading = false
        state.error = payload.message
      })
      .addCase(getNodePosition.pending, (state) => {
        state.isLoading = true
        state.error = ''
      })
      .addCase(getNodePosition.fulfilled, (state, { payload }: any) => {
        state.isLoading = false
        state.isBecomeNode = true
        state.node = payload.queueEntry
      })
      .addCase(getNodePosition.rejected, (state, { payload }: any) => {
        state.isLoading = false
      })
      .addCase(leaveNodeOperatorQueue.pending, (state) => {
        state.isLoading = true
        state.isLeavingQueue = true
        state.isLeavingQueueSuccess = false
        state.isLeavingQueueMessage = ''
        state.isLeavingQueueError = ''
      })
      .addCase(leaveNodeOperatorQueue.fulfilled, (state, { payload }: any) => {
        console.log('Queue left successfully. Resetting node state.') // Debugging
        state.isLoading = false
        state.isBecomeNode = false
        state.isLeavingQueue = false
        state.isLeavingQueueSuccess = true
        state.isLeavingQueueMessage = payload.message
        state.isLeavingQueueError = ''
        state.node = null
      })
      .addCase(leaveNodeOperatorQueue.rejected, (state, { payload }: any) => {
        state.isLoading = false
        state.error = payload.message
        state.isLeavingQueue = false
        state.isLeavingQueueSuccess = false
        state.isLeavingQueueError = payload.message
        state.isLeavingQueueMessage = ''
      })
      .addCase(setRegistrationWindow.pending, (state) => {
        state.isLoading = true
        state.isSetRegistrationWindowError = ''
        state.isSetRegistrationWindowMessage = ''
        state.isSetRegistrationWindowSuccess = false
      })
      .addCase(setRegistrationWindow.fulfilled, (state, { payload }: any) => {
        state.isLoading = false
        state.isSetRegistrationWindowSuccess = true
        state.isSetRegistrationWindowMessage = payload.message
        state.isSetRegistrationWindowError = ''
        state.registrationWindow = payload.window
      })
      .addCase(setRegistrationWindow.rejected, (state, { payload }: any) => {
        state.isLoading = false
        state.error = payload.message
        state.isSetRegistrationWindowSuccess = false
        state.isSetRegistrationWindowMessage = ''
      })
      .addCase(getRegistrationWindowStatus.pending, (state) => {
        state.isLoading = true
        state.error = ''
      })
      .addCase(
        getRegistrationWindowStatus.rejected,
        (state, { payload }: any) => {
          state.isLoading = false
          state.error = payload.message
        },
      )
      .addCase(
        getRegistrationWindowStatus.fulfilled,
        (state, { payload }: any) => {
          state.isLoading = false
          state.isRegistrationWindowStarted = true
          state.registrationWindow = payload.window
        },
      )
      .addCase(stopRegistrationWindow.pending, (state) => {
        state.isLoading = true
        state.error = ''
      })
      .addCase(stopRegistrationWindow.rejected, (state, { payload }: any) => {
        state.isLoading = false
        state.error = payload.message
      })
      .addCase(stopRegistrationWindow.fulfilled, (state, { payload }: any) => {
        state.isLoading = false
        state.isRegistrationWindowStarted = false
        state.registrationWindow = null
        state.message = payload.message
      })
  },
})

export const { reducer, actions } = becomeNodeSlice
export const { messageCleanUp } = becomeNodeSlice.actions

export default becomeNodeSlice
